
import uniqid from 'uniqid'

const detectBrowser = ()=>{
  var sBrowser, sUsrAg = navigator.userAgent;

  //The order matters here, and this may report false positives for unlisted browsers.

  if (sUsrAg.indexOf("Firefox") > -1) {
       sBrowser = "Firefox";
       //"Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
  } else if (sUsrAg.indexOf("Opera") > -1) {
       sBrowser = "Opera";
  } else if (sUsrAg.indexOf("Trident") > -1) {
       sBrowser = "Explorer";
       //"Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
  } else if (sUsrAg.indexOf("Edge") > -1) {
       sBrowser = "Edge";
       //"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
  } else if (sUsrAg.indexOf("Chrome") > -1) {
      sBrowser = "Chrome";
      //"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
  } else if (sUsrAg.indexOf("Safari") > -1) {
      sBrowser = "Safari";
      //"Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
  } else {
      sBrowser = "unknown";
  }

  return sBrowser
}


const isMobile = ()=>{
  if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)){
   return true
 }

 return false
}

export const userDeviceCheck = (auth, cookies, updateUserDevices, showWebpageDisplayedInfo)=>{
  let devices = auth.devices
  let deviceId = cookies.get("device_id")
  //console.log(devices, deviceId)
  if(!deviceId){
    deviceId = uniqid("deviceId-")
    cookies.set("device_id", deviceId, {path: "/", maxAge: 60*60*24*365*5})
  }

  if(!devices){
    devices = {
      maxDevicesNum: 3,
      maxDevicesChanged: 3,
      data: {
        [deviceId]:{
          type: isMobile() ? "Mobile":"Desktop",
          timestamp: Date.now(),
          platform: navigator.platform,
          browser: detectBrowser()
        }
      }
    }
    updateUserDevices( auth.uid, devices)

    return true
  }else if(devices.data && !devices.data[deviceId]){
    if(Object.keys(auth.devices.data).length < auth.devices.maxDevicesNum){
      devices.data = {
          ...devices.data,
          [deviceId]:{
            type: isMobile() ? "Mobile":"Desktop",
            timestamp: Date.now(),
            platform: navigator.platform,
            browser: detectBrowser(),
          }
        }
      updateUserDevices(auth.uid, devices)

      return true
    }else{
      showWebpageDisplayedInfo("Prekoračil si število naprav na uporabnika!", "V kolikor želiš dostopati do plačljivih vsebin, dodeli dostop trenutni napravi!", "error")

      return false
    }
  }

  return true
}



// WEBPACK FOOTER //
// ./src/userDeviceCheck.js